export default __webpack_public_path__ + "269ffa61445437c541edc936289dc82c.svg";